module.exports = __webpack_public_path__ + "img/background.7ed311dc.svg";